import { useState, ReactNode } from 'react'
import cn from 'clsx'

// Components
import { Dropdown, Slider, IconCloseFat } from '@tracklib/kit'

import styles from './sliderdropdown.css'

type SelectedOptionsProps = {
  count: number
  onClear?: () => void
  className?: string
}

export const SelectedOptions = ({ count, onClear, className }: SelectedOptionsProps): JSX.Element | null => {
  if (!count) {
    return null
  }

  return (
    <div
      className={cn(styles.selectedOptions, onClear && styles.onClear, className)}
      onClick={e => {
        if (onClear) {
          e.stopPropagation()
          return onClear()
        }
        return null
      }}
      role="button"
      tabIndex={0}
    >
      {count}
      <IconCloseFat />
    </div>
  )
}

type SliderDropdownProps = {
  label: ReactNode
  labelSeparation?: number
  max: number
  min: number
  values: Array<number>
  onChange?: (args: readonly number[]) => void
  onClear: () => void
  onUpdate?: (args: readonly number[]) => void
  className?: string
  labelClassName?: string
  listClassName?: string
  selectedOptionsClassName?: string
  closesOnBackdropClick?: boolean
  datatesting?: string
}

const SliderDropdown = ({
  label,
  onChange,
  onUpdate,
  onClear,
  min,
  max,
  values,
  labelSeparation,
  className,
  labelClassName,
  listClassName,
  closesOnBackdropClick,
  selectedOptionsClassName,
  datatesting,
}: SliderDropdownProps): JSX.Element => {
  const [active, toggleActive] = useState(false)
  const [minValue, maxValue] = values
  const changed = +(minValue !== min) + +(maxValue !== max)

  return (
    <Dropdown
      active={active}
      onToggle={() => toggleActive(!active)}
      label={
        <>
          {label}
          <SelectedOptions className={selectedOptionsClassName} count={changed} onClear={onClear} />
        </>
      }
      className={className}
      labelClassName={labelClassName}
      closesOnBackdropClick={!!closesOnBackdropClick}
      listClassName={cn(styles.list, listClassName)}
      datatesting={datatesting}
    >
      {!max ? (
        <Dropdown.Item className={styles.loading}>Loading…</Dropdown.Item>
      ) : (
        <Dropdown.Item className={styles.item}>
          <Slider
            onChange={onChange}
            onUpdate={onUpdate}
            min={min}
            max={max}
            values={values}
            labelSeparation={labelSeparation}
            className={styles.slider}
          />
        </Dropdown.Item>
      )}
    </Dropdown>
  )
}

export default SliderDropdown
